import JourneyElementTypes from './JourneyElementTypes.js';

const mediaTypes = [
  JourneyElementTypes.WEBSITE,
  JourneyElementTypes.MOBILE_APP,
  JourneyElementTypes.ECOM,
  JourneyElementTypes.STORE,
];

export default mediaTypes;
